module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-6-269a5a7e9fc775c51ae3f350d534dd53.webp";